import React, { useState, useEffect } from 'react';

interface TimedModalProps {
  component: React.ElementType;
  delay: number;
}

const TimedModal = ({ component: Component, delay }: TimedModalProps): JSX.Element => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowModal(true);
    }, delay);

    return () => clearTimeout(timeout);
  }, []);

  if (showModal) {
    return <Component open />;
  }

  return <></>;
};

export default TimedModal;
